import { useCallback, useEffect } from 'react';
import { useConfig } from 'core/common/hooks';

type PaymentMessage = {
  type: 'success' | 'fail';
};

type Params = {
  paymentFailed: () => void;
  paymentSucceed: () => void;
};

export const useThreeDomainSecurePaymentListener = ({ paymentSucceed, paymentFailed }: Params) => {
  const { paymentTrustedOrigin } = useConfig();

  const paymentListener = useCallback(
    (event: MessageEvent) => {
      if (event.origin !== paymentTrustedOrigin) {
        return;
      }

      const { type } = event.data as PaymentMessage;

      if (type === 'fail') {
        paymentFailed();
        return;
      }

      if (type === 'success') {
        paymentSucceed();
        return;
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [paymentFailed, paymentSucceed],
  );

  useEffect(() => {
    window.addEventListener('message', paymentListener);

    return () => {
      window.removeEventListener('message', paymentListener);
    };
  }, [paymentListener]);
};
